import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "../../services/usersService";

export const getAllUsers = createAsyncThunk(
  "usesrs/users",
  async (companyId: string, { rejectWithValue }) => {
    try {
      return await API.getOktaBypassUsers(companyId);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const searchAllUsers = createAsyncThunk(
  "usesrs/search",
  async (search: string, { rejectWithValue }) => {
    try {
      return await API.searchUsers(search);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
